<script>

export default {
  name: "Form",
  inject: ["content"],
  data() {
    return {
      title: "Formularz",
      subscription: true,
      modalShow: false,
      amount: 0,
      counter: 0,
      counterNum: 0,
      oneTimePayment: false,
      showCreditCard: false,
      hideSingle: false,
      showBlik: true,
      showBlikNum: false,
      selectAdoptionType: false,
      selectAmountInfo: false,
      windowWidth: 0,
      showVideo: false,
      showTooltipButonSub: true,
      amounts: [30, 50, 100],
      inputAmount: "",
      form: {
        inviteToPay: new URLSearchParams(location.search).get("inviteToPay"),
        inviteToSinglePayment: new URLSearchParams(location.search).get(
          "inviteToSinglePayment"
        ),
        // utmSource: new URLSearchParams(location.search).get("utm_source"),
        // utmMedium: new URLSearchParams(location.search).get("utm_medium"),
        // utmCampaign: new URLSearchParams(location.search).get("utm_campaign"),
        // utmTerm: new URLSearchParams(location.search).get("utm_term"),
        // utmContent: new URLSearchParams(location.search).get("utm_content"),
        fundraiser: new URLSearchParams(location.search).get("fundraiser"),
        tag: new URLSearchParams(location.search).get("tag"),
        email: "",
        recipient: "",
        name: "",
        surname: "",
        phone: "",
        agreementData: [],
        contactType: [],
        amount: this.amount,
        blik: "",
        cvv: "",
        cyy: "",
        cmm: "",
        pcard: "",
        payuAgreement: [],
      },
    };
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
  watch: {
    modalShow: function () {
      if (this.modalShow) {
        document.title = "Kochamy lasy" + " | " + "Formularz adopcji";
      } else {
        document.title =
          "Kochamy Lasy" +
          " | " +
          "Kochamt Lasy";
      }
    },
  },

  components: {},
  props: {
    thanks: Boolean,
  },
  mounted() {
    this.form.amount = parseFloat(this.amount);
  },
  created() {
    window.scroll({
      top: 0,
      left: 0,
    });
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
